;(function($, window, document, undefined) {
    'use strict';

    var pluginName = 'schedulerjs';
    var instanceCounter = 0;

    function formatTime(timeStr, use12Hour) {
        if (use12Hour) return moment(timeStr, 'HH:mm').format('h:mm A');
        return timeStr;
    }

    var defaults = {
        use12Hour: false,
        pixelsPerHour: 200,
        snapTo: 5,
        steps: ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'],
        headName: 'Names',
        list: [],
        renderTitle: null,
        start: undefined,
        end: undefined,
        onClickAppointment: null,
        renderName: null,
        peakHours: [],
        contextMenu: {
            enabled: true,
            renderHeader: null,
            renderDetails: null,
            items: []
        },
        onDragEnd: null,
        onSelectionChange: null
    };

    function Scheduler(element, options) {
        this.$element = $(element);
        this.opts = $.extend(true, {}, defaults, options);
        this._instanceId = instanceCounter++;

        this.minMinutes = 0;
        this.maxMinutes = 1440;
        this.start = 0;
        this.end = 0;
        this.stepsMinutes = [];
        this.nameList = [];
        this.payloadById = {};
        this.selectedPayloadIds = new Set();

        this._$popup = null;
        this._$activeCol = null;
        this._activePayload = null;

        // Check if there's a saved scroll from a prior instance (re-init)
        var savedScroll = this.$element.data(pluginName + '_savedScroll');
        this._scrolledToCurrentTime = savedScroll !== undefined;

        this._buildDOM();
        this._setListeners();
        this._initSelection();
        this._renderCurrentTimeLine();
        this._startTimeLineUpdate();

        // Restore saved scroll after DOM is built
        if (savedScroll !== undefined) {
            var $appCol = this.$element.find('.sjs-app-col').first();
            if ($appCol.length) $appCol.scrollLeft(savedScroll);
            this.$element.removeData(pluginName + '_savedScroll');
        }
    }

    // ── Time Utilities ──────────────────────────────────────────

    Scheduler.prototype.timeStrToMinutes = function(str) {
        var split = str.split(':');
        return parseInt(split[0], 10) * 60 + parseInt(split[1], 10);
    };

    Scheduler.prototype.minutesToTimeStr = function(minutes) {
        var h24 = Math.floor(minutes / 60) % 24;
        var mins = minutes % 60;
        var timeStr = (h24 < 10 ? '0' : '') + String(h24) + ':' + (mins < 10 ? '0' : '') + String(mins);
        return this.opts.use12Hour ? moment(timeStr, 'HH:mm').format('h:mm A') : timeStr;
    };

    Scheduler.prototype.minutesToPixels = function(minutes) {
        return Math.round(minutes * this.opts.pixelsPerHour / 60);
    };

    Scheduler.prototype.pixelsToMinutes = function(pixels) {
        return Math.round(60 * pixels / this.opts.pixelsPerHour);
    };

    Scheduler.prototype.getGridOffset = function() {
        return this.$element.find('.sjs-grid').first().offset().left;
    };

    Scheduler.prototype.minutesToPageOffset = function(minutes) {
        return this.minutesToPixels(minutes - this.minMinutes) + this.getGridOffset();
    };

    Scheduler.prototype.pageOffsetToMinutes = function(pageOffset) {
        return this.pixelsToMinutes(pageOffset - this.getGridOffset()) + this.minMinutes;
    };

    // ── DOM Building ────────────────────────────────────────────

    Scheduler.prototype._buildDOM = function() {
        this.nameList = this.opts.list.map(function(elem) {
            return $.extend({ name: elem.name }, elem);
        });

        this.stepsMinutes = this.opts.steps.map(this.timeStrToMinutes);

        // Normalize wrap-around: make steps monotonically increasing
        this.minMinutes = this.stepsMinutes[0];
        this.maxMinutes = this.stepsMinutes[this.stepsMinutes.length - 1];
        for (var i = 1; i < this.stepsMinutes.length; i++) {
            if (this.stepsMinutes[i] < this.stepsMinutes[i - 1]) {
                this.stepsMinutes[i] += 1440;
            }
        }
        this.maxMinutes = this.stepsMinutes[this.stepsMinutes.length - 1];

        var gridColsHead = [];
        var gridCols = [];
        for (var i = 0; i < this.stepsMinutes.length - 1; i++) {
            var length = this.stepsMinutes[i + 1] - this.stepsMinutes[i];
            var headerTime = formatTime(this.opts.steps[i], this.opts.use12Hour);
            gridColsHead.push({ width: this.minutesToPixels(length), time: headerTime });
            gridCols.push({ width: this.minutesToPixels(length) });
        }

        // Wrap-around column: last step → first step (next day)
        var firstMin = this.timeStrToMinutes(this.opts.steps[0]);
        var lastMin = this.timeStrToMinutes(this.opts.steps[this.opts.steps.length - 1]);
        this.wrapEnd = null;
        if (lastMin < firstMin) {
            this.wrapEnd = this.stepsMinutes[0] + 1440;
            var wrapLength = this.wrapEnd - this.stepsMinutes[this.stepsMinutes.length - 1];
            var wrapHeaderTime = formatTime(this.opts.steps[this.opts.steps.length - 1], this.opts.use12Hour);
            gridColsHead.push({ width: this.minutesToPixels(wrapLength), time: wrapHeaderTime });
            gridCols.push({ width: this.minutesToPixels(wrapLength) });
        }

        var html = '<div class="sjs-wrapper">';

        // Name column
        html += '<div class="sjs-name-col">';
        html += '<div class="sjs-name-head">' + this.opts.headName + '</div>';
        for (i = 0; i < this.nameList.length; i++) {
            var nameContent;
            if (this.opts.renderName) {
                nameContent = this.opts.renderName(this.nameList[i]);
            } else {
                nameContent = this.nameList[i].name;
            }
            html += '<div class="sjs-name">' + nameContent + '</div>';
        }
        html += '</div>';

        // Appointment column
        html += '<div class="sjs-app-col">';

        // Grid
        html += '<div class="sjs-grid">';
        html += '<div class="sjs-grid-row-head">';
        for (i = 0; i < gridColsHead.length; i++) {
            html += '<div class="sjs-grid-col-head" style="width:' + gridColsHead[i].width + 'px;">' + gridColsHead[i].time + '</div>';
        }
        html += '</div>';
        for (i = 0; i < this.opts.list.length; i++) {
            html += '<div class="sjs-grid-row">';
            for (var j = 0; j < gridCols.length; j++) {
                html += '<div class="sjs-grid-col" style="width:' + gridCols[j].width + 'px;"></div>';
            }
            html += '</div>';
        }
        html += '</div>';

        // Overlay
        html += '<div class="sjs-grid-overlay">';
        html += '<div class="sjs-grid-overlay-row-head">';

        // Peak hour markers
        if (this.opts.peakHours && this.opts.peakHours.length > 0) {
            for (var p = 0; p < this.opts.peakHours.length; p++) {
                var range = this.opts.peakHours[p];
                var peakStart = this.timeStrToMinutes(range[0]);
                var peakEnd = this.timeStrToMinutes(range[1]);
                if (peakEnd <= peakStart) peakEnd += 1440;

                // Clamp to visible grid
                var visStart = Math.max(peakStart, this.minMinutes);
                var visEnd = Math.min(peakEnd, this.maxMinutes);
                if (visEnd <= visStart) continue;

                var markerLeft = this.minutesToPixels(visStart - this.minMinutes);
                var markerWidth = this.minutesToPixels(visEnd - visStart);
                html += '<div class="sjs-peak-hour-marker" style="left:' + markerLeft + 'px;width:' + markerWidth + 'px;"></div>';
            }
        }

        html += '</div>';
        var overlayData = this._getGridOverlayData();
        for (i = 0; i < overlayData.length; i++) {
            html += '<div class="sjs-grid-overlay-row">';
            for (j = 0; j < overlayData[i].cols.length; j++) {
                var col = overlayData[i].cols[j];
                if (col.wrapped) {
                    html += '<div class="sjs-grid-overlay-col ' + col.className + ' sjs-grid-overlay-col-abs" ';
                    html += 'style="width:' + col.width + 'px;left:' + col.left + 'px;" ';
                } else {
                    html += '<div class="sjs-grid-overlay-col ' + col.className + '" ';
                    html += 'style="width:' + col.width + 'px;margin-left:' + col.margin + 'px;" ';
                }
                html += 'data-payload-id="' + col.payloadId + '">';
                html += col.title;
                html += '</div>';
            }
            html += '</div>';
        }
        html += '</div>';

        // Selector
        html += '<div class="sjs-selector">';
        html += '<div class="sjs-selector-inner">';
        html += '<div class="sjs-selector-edge sjs-selector-left"></div>';
        html += '<div class="sjs-selector-grip"><i class="fas fa-grip-vertical"></i></div>';
        html += '<div class="sjs-selector-text"></div>';
        html += '<div class="sjs-selector-edge sjs-selector-right"></div>';
        html += '</div>';
        html += '</div>';

        // Fill height (dummy for absolute positioned grid)
        html += '<div class="sjs-fill-height"></div>';

        html += '</div>'; // sjs-app-col
        html += '</div>'; // sjs-wrapper

        this.$element.html(html);

        var gridHeight = this.$element.find('.sjs-grid').first().height();
        var extraHeight = 22;
        var selectorsMarginTop = 15;
        this.$element.find('.sjs-fill-height').first().height(gridHeight + extraHeight);
        this.$element.find('.sjs-selector').height(gridHeight + extraHeight - selectorsMarginTop);
    };

    // ── Current Time Line ──────────────────────────────────────

    Scheduler.prototype._renderCurrentTimeLine = function() {
        var $grid = this.$element.find('.sjs-grid').first();
        var $appCol = this.$element.find('.sjs-app-col').first();
        if (!$grid.length || !$appCol.length) return;

        var now = new Date();
        var utcMinutes = now.getUTCHours() * 60 + now.getUTCMinutes();
        var currentMinutes = utcMinutes + 360; // UTC+6 for Dhaka
        if (currentMinutes >= 1440) currentMinutes -= 1440;

        // Normalize for wrap-around (e.g., if steps go past midnight)
        var normalizedCurrent = currentMinutes;
        if (currentMinutes < this.minMinutes) {
            normalizedCurrent = currentMinutes + 1440;
        }

        // Only show if current time is within the visible grid range
        var maxVisible = this.wrapEnd || this.maxMinutes;
        if (normalizedCurrent < this.minMinutes || normalizedCurrent > maxVisible) {
            this.$element.find('.sjs-current-time-line').remove();
            return;
        }

        var leftPixels = this.minutesToPixels(normalizedCurrent - this.minMinutes);
        var gridOffsetTop = $grid.position().top;
        var gridHeight = $grid.height();
        var timeLabel = this.minutesToTimeStr(normalizedCurrent);

        var $existing = this.$element.find('.sjs-current-time-line');
        if ($existing.length) {
            $existing.css('left', leftPixels + 'px');
            $existing.find('.sjs-current-time-label').text(timeLabel);
        } else {
            var html = '<div class="sjs-current-time-line" style="left:' + leftPixels + 'px;">';
            html += '<div class="sjs-current-time-dot"></div>';
            html += '<div class="sjs-current-time-label">' + timeLabel + '</div>';
            html += '<div class="sjs-current-time-stripe"></div>';
            html += '</div>';
            $appCol.css('position', 'relative').append(html);
        }

        var containerWidth = $appCol.width();
        if (!this._scrolledToCurrentTime) {
            $appCol.scrollLeft(leftPixels - containerWidth / 2);
            this._scrolledToCurrentTime = true;
        }
    };

    Scheduler.prototype._startTimeLineUpdate = function() {
        var self = this;
        this._timeLineInterval = setInterval(function() {
            self._renderCurrentTimeLine();
        }, 60000);
    };

    Scheduler.prototype._getGridOverlayData = function() {
        var rows = [];
        var payloadId = 0;

        for (var i = 0; i < this.opts.list.length; i++) {
            var prevEnd = this.minMinutes;
            var appointments = this.opts.list[i].appointments;

            // Normalize: handle midnight span, clamp to grid, skip if outside
            var parsedApps = [];
            for (var a = 0; a < appointments.length; a++) {
                var app = appointments[a];
                var s = this.timeStrToMinutes(app.start);
                var e = this.timeStrToMinutes(app.end);

                // Midnight span: end < start means it crosses midnight
                if (e < s) e += 1440;

                // Skip if entirely outside the visible grid (after grid end)
                if (s >= this.maxMinutes) continue;

                // If entirely before grid start, normalize to next day if in main grid range
                if (e < this.minMinutes) {
                    var firstMin = this.timeStrToMinutes(this.opts.steps[0]);
                    var lastMin = this.timeStrToMinutes(this.opts.steps[this.opts.steps.length - 1]);
                    var inWrapRange = lastMin < firstMin && e > lastMin;
                    if (!inWrapRange) {
                        s += 1440;
                        e += 1440;
                    }
                }

                if (s < this.minMinutes && e > this.minMinutes) {
                    // Spans grid start: split into grid body + wrap tail
                    parsedApps.push({ start: this.minMinutes, end: e, original: app });
                    var wrapTailEnd = this.wrapEnd ? Math.min(e + 1440, this.wrapEnd) : e + 1440;
                    parsedApps.push({ start: s + 1440, end: wrapTailEnd, original: app, wrapped: true });
                } else if (s < this.minMinutes && e <= this.minMinutes) {
                    // Entirely before grid: place in wrap column
                    var wrapEnd = this.wrapEnd ? Math.min(e + 1440, this.wrapEnd) : e + 1440;
                    parsedApps.push({ start: s + 1440, end: wrapEnd, original: app, wrapped: true });
                } else {
                    // Normal: clamp to grid boundaries
                    if (e > this.maxMinutes) e = this.maxMinutes;
                    parsedApps.push({ start: s, end: e, original: app });
                }
            }

            var cols = [];
            for (var j = 0; j < parsedApps.length; j++) {
                var appInfo = parsedApps[j];
                var appointment = appInfo.original;

                var minutesStart = appInfo.start;
                var minutesEnd = appInfo.end;

                var length = minutesEnd - minutesStart;
                var lengthSinceLast = minutesStart - prevEnd;
                prevEnd = appInfo.wrapped ? prevEnd : minutesEnd;

                var hasOverlap = false;
                for (var k = 0; k < parsedApps.length; k++) {
                    if (j === k) continue;
                    var other = parsedApps[k];
                    if (minutesStart < other.end && other.start < minutesEnd) {
                        hasOverlap = true;
                        break;
                    }
                }

                var className = '';
                if (appointment.payload !== undefined) {
                    className += 'sjs-grid-overlay-col-clickable ';
                }
                className += hasOverlap ? 'sjs-color-red ' : 'sjs-color-blue ';
                if (appointment.class !== undefined) {
                    className += appointment.class;
                }

                this.payloadById[payloadId] = $.extend({}, appointment.payload || {}, {
                    start: appointment.start,
                    end: appointment.end,
                    title: appointment.title,
                    _gridStart: appInfo.start,
                    _gridEnd: appInfo.end
                });

                var renderedTitle = this.opts.renderTitle
                    ? this.opts.renderTitle(appointment, payloadId)
                    : appointment.title;

                cols.push({
                    width: this.minutesToPixels(length),
                    margin: appInfo.wrapped ? 0 : this.minutesToPixels(lengthSinceLast),
                    className: className,
                    title: renderedTitle,
                    payloadId: payloadId,
                    wrapped: !!appInfo.wrapped,
                    left: appInfo.wrapped ? this.minutesToPixels(minutesStart - this.minMinutes) : null
                });

                payloadId++;
            }

            rows.push({ cols: cols });
        }

        return rows;
    };

    // ── Selection ───────────────────────────────────────────────

    Scheduler.prototype._initSelection = function() {
        this.start = this.minMinutes + 60;
        this.end = this.start + 60;

        if (this.opts.start !== undefined) {
            this.start = this.timeStrToMinutes(this.opts.start);
        }
        if (this.opts.end !== undefined) {
            this.end = this.timeStrToMinutes(this.opts.end);
        }

        this._updateSelector();
    };

    Scheduler.prototype._updateSelector = function() {
        var $selector = this.$element.find('.sjs-selector');
        $selector.offset({ left: this.minutesToPageOffset(this.start) });
        $selector.width(this.minutesToPixels(this.end - this.start));
        $selector.find('.sjs-selector-text').html(
            this.minutesToTimeStr(this.start) + ' - ' + this.minutesToTimeStr(this.end)
        );
    };

    Scheduler.prototype._snapSelector = function() {
        var startSnap = this.start % this.opts.snapTo;
        var endSnap = this.end % this.opts.snapTo;

        this.start += startSnap > this.opts.snapTo / 2
            ? this.opts.snapTo - startSnap
            : -startSnap;
        this.end += endSnap > this.opts.snapTo / 2
            ? this.opts.snapTo - endSnap
            : -endSnap;

        this._updateSelector();
    };

    Scheduler.prototype._resizeSelectorLeft = function(delta) {
        this.start += delta;
        if (this.start < this.minMinutes) this.start = this.minMinutes;
        if (this.end - this.start < this.opts.snapTo) this.start = this.end - this.opts.snapTo;
    };

    Scheduler.prototype._resizeSelectorRight = function(delta) {
        this.end += delta;
        if (this.end > this.maxMinutes) this.end = this.maxMinutes;
        if (this.end - this.start < this.opts.snapTo) this.end = this.start + this.opts.snapTo;
    };

    Scheduler.prototype._moveSelector = function(delta) {
        this.start += delta;
        this.end += delta;

        if (this.start < this.minMinutes) {
            this.end += this.minMinutes - this.start;
            this.start = this.minMinutes;
        }
        if (this.end > this.maxMinutes) {
            this.start += this.maxMinutes - this.end;
            this.end = this.maxMinutes;
        }
        if (this.end - this.start < this.opts.snapTo) {
            this.end = this.start + this.opts.snapTo;
        }
    };

    // ── Context Menu ────────────────────────────────────────────

    Scheduler.prototype._showContextMenu = function(payload, event) {
        this._hideContextMenu();

        var menuConfig = this.opts.contextMenu;
        if (!menuConfig || !menuConfig.enabled) return;

        this._activePayload = payload;
        this._$activeCol = $(event.target).closest('.sjs-grid-overlay-col');
        if (this._$activeCol.length) {
            this._$activeCol.addClass('sjs-grid-overlay-col-active');
        }

        var html = '<div class="scheduler-popup-menu">';

        // Header
        if (menuConfig.renderHeader) {
            html += '<div class="scheduler-popup-header">' + menuConfig.renderHeader(payload) + '</div>';
        }

        // Details
        if (menuConfig.renderDetails) {
            html += menuConfig.renderDetails(payload);
        }

        // Menu items
        if (menuConfig.items && menuConfig.items.length > 0) {
            html += '<div class="scheduler-popup-divider"></div>';
            for (var i = 0; i < menuConfig.items.length; i++) {
                var item = menuConfig.items[i];
                if (item.show && !item.show(payload)) continue;

                if (item.type === 'divider') {
                    html += '<div class="scheduler-popup-divider"></div>';
                    continue;
                }

                var href = '#';
                if (typeof item.href === 'function') {
                    href = item.href(payload);
                } else if (typeof item.href === 'string') {
                    href = item.href;
                }

                var classes = 'scheduler-popup-item';
                if (item.className) classes += ' ' + item.className;

                var attrs = ' data-menu-idx="' + i + '"';
                if (item.id) attrs += ' id="' + item.id + '"';
                if (item.attrs) {
                    for (var key in item.attrs) {
                        if (item.attrs.hasOwnProperty(key)) {
                            attrs += ' ' + key + '="' + item.attrs[key] + '"';
                        }
                    }
                }

                html += '<a href="' + href + '" class="' + classes + '"' + attrs + '>';
                if (item.icon) html += '<i class="' + item.icon + '"></i> ';
                html += item.label + '</a>';
            }
        }

        html += '</div>';

        this._$popup = $(html);
        $('body').append(this._$popup);

        this._positionContextMenu(this._$popup, event);

        var self = this;
        var menuItems = menuConfig.items;

        // Click handler for menu items
        this._$popup.on('click.schedulerPopup', '[data-menu-idx]', function(e) {
            var idx = parseInt($(this).data('menu-idx'), 10);
            var menuItem = menuItems[idx];
            if (menuItem && menuItem.onClick) {
                e.preventDefault();
                e.stopPropagation();
                menuItem.onClick.call(self, self._activePayload, e, self._$activeCol, function() {
                    self._hideContextMenu();
                });
            }
        });

        // Click outside to close
        $(document).off('click.schedulerPopup');
        setTimeout(function() {
            $(document).on('click.schedulerPopup', function(e) {
                if (self._$popup && !self._$popup.is(e.target) && self._$popup.has(e.target).length === 0) {
                    self._hideContextMenu();
                }
            });
        }, 0);

        // Tab key navigation
        $(document).off('keydown.schedulerTab');
        $(document).on('keydown.schedulerTab', function(e) {
            if (self._$popup && e.key === 'Tab') {
                e.preventDefault();
                self._showNextSlot();
            }
        });
    };

    Scheduler.prototype._hideContextMenu = function() {
        $(document).off('keydown.schedulerTab');
        if (this._$activeCol) {
            this._$activeCol.removeClass('sjs-grid-overlay-col-active');
            this._$activeCol = null;
        }
        if (this._$popup) {
            this._$popup.remove();
            this._$popup = null;
        }
        this._activePayload = null;
    };

    Scheduler.prototype._positionContextMenu = function($menu, event) {
        var posX = event.pageX + 10;
        var posY = event.pageY + 10;
        var popW = $menu.outerWidth();
        var popH = $menu.outerHeight();

        if (posX + popW > $(window).width() + $(window).scrollLeft()) {
            posX = event.pageX - popW - 10;
        }
        if (posY + popH > $(window).height() + $(window).scrollTop()) {
            posY = event.pageY - popH - 10;
        }

        $menu.css({ top: posY, left: posX });
    };

    Scheduler.prototype._showNextSlot = function() {
        if (!this._$activeCol) return;
        var $clickableCols = this.$element.find('.sjs-grid-overlay-col-clickable').not('.sjs-hidden-slot');
        var idx = $clickableCols.index(this._$activeCol);
        if (idx === -1) return;
        var $next = $clickableCols.eq(idx + 1);
        if ($next.length === 0) $next = $clickableCols.first();
        if (!$next.length) return;

        var payloadId = $next.data('payload-id');
        if (this.payloadById[payloadId]) {
            var off = $next.offset();
            var fakeEvent = { pageX: off.left + 10, pageY: off.top + 10, target: $next[0] };
            this._showContextMenu(this.payloadById[payloadId], fakeEvent);
        }
    };

    // ── Selection Management ─────────────────────────────────────

    Scheduler.prototype._toggleSelection = function(payloadId, $col) {
        if (this.selectedPayloadIds.has(payloadId)) {
            this.selectedPayloadIds.delete(payloadId);
            $col.removeClass('sjs-grid-overlay-col-selected');
        } else {
            this.selectedPayloadIds.add(payloadId);
            $col.addClass('sjs-grid-overlay-col-selected');
        }
        this._fireSelectionChange();
    };

    Scheduler.prototype.clearSelection = function() {
        this.selectedPayloadIds.clear();
        this.$element.find('.sjs-grid-overlay-col-selected').removeClass('sjs-grid-overlay-col-selected');
        this._fireSelectionChange();
    };

    Scheduler.prototype._fireSelectionChange = function() {
        if (this.opts.onSelectionChange) {
            this.opts.onSelectionChange.call(this, Array.from(this.selectedPayloadIds));
        }
    };

    Scheduler.prototype.getSelectedScheduleIds = function() {
        var self = this;
        return Array.from(this.selectedPayloadIds).map(function(payloadId) {
            var payload = self.payloadById[payloadId];
            return payload ? payload.id : null;
        }).filter(function(id) { return id !== null; });
    };

    // ── Event Listeners ─────────────────────────────────────────

    Scheduler.prototype._setListeners = function() {
        var that = this;
        var ns = '.schedulerjsApptDrag' + this._instanceId;
        var $dragEl = null;
        var $edgeLeft = null;
        var $edgeRight = null;
        var offset = null;
        var wasDragging = false;

        // ── Appointment Drag ───────────────────────────────────────
        var $apptDragEl = null;
        var apptDragStartX = 0;
        var apptDragPayload = null;
        var apptDragOrigStart = 0;
        var apptDragOrigEnd = 0;
        var apptDragStarted = false;
        var wasDraggingAppointment = false;

        function toHHMM(minutes) {
            var h = Math.floor(minutes / 60) % 24;
            var m = Math.round(minutes) % 60;
            return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m;
        }

        this.$element.on('mousemove.schedulerjs', function(e) {
            if ($dragEl) {
                wasDragging = true;
                that._moveSelector(that.pageOffsetToMinutes(e.pageX - offset) - that.start);
                that._updateSelector();
            } else if ($edgeLeft) {
                that._resizeSelectorLeft(that.pageOffsetToMinutes(e.pageX - offset) - that.start);
                that._updateSelector();
            } else if ($edgeRight) {
                that._resizeSelectorRight(that.pageOffsetToMinutes(e.pageX - offset) - that.end);
                that._updateSelector();
            }
        });

        // Grip — start selector drag
        this.$element.on('mousedown.schedulerjs', '.sjs-selector-grip', function(e) {
            if (e.which !== 1) return;
            e.stopPropagation();
            wasDragging = false;
            $dragEl = $(this).closest('.sjs-selector');
            $edgeLeft = null;
            $edgeRight = null;
            var selOffset = $dragEl.offset();
            offset = e.pageX - selOffset.left;
        });

        // Selector body — peek through for appointment drag (no selector move)
        this.$element.on('mousedown.schedulerjs', '.sjs-selector', function(e) {
            if (e.which !== 1) return;
            if ($(e.target).closest('.sjs-selector-grip').length) return;

            var $sel = $(this);
            $sel.css('pointer-events', 'none');
            var underneath = document.elementFromPoint(e.clientX, e.clientY);
            $sel.css('pointer-events', '');

            if (underneath) {
                var $col = $(underneath).closest('.sjs-grid-overlay-col-clickable');
                if ($col.length) {
                    var payloadId = $col.data('payload-id');
                    var payload = that.payloadById[payloadId];
                    if (payload) {
                        e.preventDefault();
                        e.stopPropagation();
                        $apptDragEl = $col;
                        apptDragStartX = e.pageX;
                        apptDragPayload = payload;
                        apptDragOrigStart = payload._gridStart !== undefined ? payload._gridStart : that.timeStrToMinutes(payload.start);
                        apptDragOrigEnd = payload._gridEnd !== undefined ? payload._gridEnd : that.timeStrToMinutes(payload.end);
                        apptDragStarted = false;
                        wasDraggingAppointment = false;
                    }
                }
            }
        });

        this.$element.on('mousedown.schedulerjs', '.sjs-selector-left', function(e) {
            e.stopPropagation();
            $dragEl = null;
            $edgeLeft = $(this);
            $edgeRight = null;
            offset = e.offsetX;
        });

        this.$element.on('mousedown.schedulerjs', '.sjs-selector-right', function(e) {
            e.stopPropagation();
            $dragEl = null;
            $edgeLeft = null;
            $edgeRight = $(this);
            offset = e.offsetX - $edgeRight.width();
        });

        this.$element.on('mouseup.schedulerjs', function() {
            if ($dragEl || $edgeLeft || $edgeRight) {
                that._snapSelector();
                $dragEl = null;
                $edgeLeft = null;
                $edgeRight = null;
            }
        });

        this.$element.on('mouseleave.schedulerjs', function() {
            if ($dragEl || $edgeLeft || $edgeRight) {
                that._snapSelector();
                $dragEl = null;
                $edgeLeft = null;
                $edgeRight = null;
            }
        });

        // Appointment click — show context menu or fire callback
        this.$element.on('click.schedulerjs', '.sjs-grid-overlay-col', function(e) {
            if (wasDraggingAppointment) {
                wasDraggingAppointment = false;
                return;
            }
            var payloadId = $(this).data('payload-id');
            if (!that.payloadById.hasOwnProperty(payloadId) || that.payloadById[payloadId] === undefined) return;

            // Cmd/Ctrl + Click → toggle selection
            if (e.metaKey || e.ctrlKey) {
                e.preventDefault();
                e.stopPropagation();
                that._hideContextMenu();
                that._toggleSelection(payloadId, $(this));
                return;
            }

            // If there are selections, clicking without modifier clears them
            if (that.selectedPayloadIds.size > 0) {
                that.clearSelection();
            }

            if (that.opts.contextMenu && that.opts.contextMenu.enabled) {
                that._showContextMenu(that.payloadById[payloadId], e);
            } else if (that.opts.onClickAppointment) {
                that.opts.onClickAppointment.call(that, that.payloadById[payloadId], e);
            }
        });

        // Right-click → show context menu
        this.$element.on('contextmenu.schedulerjs', '.sjs-grid-overlay-col', function(e) {
            if (wasDraggingAppointment) return;
            var payloadId = $(this).data('payload-id');
            if (!that.payloadById.hasOwnProperty(payloadId) || that.payloadById[payloadId] === undefined) return;

            e.preventDefault();
            if (that.opts.contextMenu && that.opts.contextMenu.enabled) {
                that._showContextMenu(that.payloadById[payloadId], e);
            }
        });

        // Click-through: allow clicking appointment columns behind the selector
        this.$element.on('click.schedulerjs', '.sjs-selector', function(e) {
            if (wasDragging) return;
            if ($(e.target).closest('.sjs-selector-grip').length) return;

            var $sel = $(this);
            $sel.css('pointer-events', 'none');
            var underneath = document.elementFromPoint(e.clientX, e.clientY);
            $sel.css('pointer-events', '');

            if (underneath) {
                var $col = $(underneath).closest('.sjs-grid-overlay-col-clickable');
                if ($col.length) {
                    $col[0].dispatchEvent(new MouseEvent('click', {
                        bubbles: true,
                        cancelable: true,
                        clientX: e.clientX,
                        clientY: e.clientY,
                        pageX: e.pageX,
                        pageY: e.pageY
                    }));
                }
            }
        });

        // ── Appointment drag: direct mousedown on exposed appointments ──
        this.$element.on('mousedown.schedulerjs', '.sjs-grid-overlay-col-clickable', function(e) {
            if (e.which !== 1) return;
            e.preventDefault();
            e.stopPropagation();

            // Clear selection on drag start (but not when Cmd/Ctrl is held for multi-select)
            if (!e.metaKey && !e.ctrlKey) {
                that.clearSelection();
            }

            var payloadId = $(this).data('payload-id');
            var payload = that.payloadById[payloadId];
            if (!payload) return;

            $apptDragEl = $(this);
            apptDragStartX = e.pageX;
            apptDragPayload = payload;
            apptDragOrigStart = payload._gridStart !== undefined ? payload._gridStart : that.timeStrToMinutes(payload.start);
            apptDragOrigEnd = payload._gridEnd !== undefined ? payload._gridEnd : that.timeStrToMinutes(payload.end);
            apptDragStarted = false;
            wasDraggingAppointment = false;
        });

        // ── Appointment drag: document-level move/up ──────────────
        $(document).on('mousemove' + ns, function(e) {
            if (!$apptDragEl) return;

            var deltaX = e.pageX - apptDragStartX;
            if (!apptDragStarted && Math.abs(deltaX) < 3) return;

            if (!apptDragStarted) {
                apptDragStarted = true;
                $apptDragEl.addClass('sjs-dragging');
            }

            // Magnetic snap: convert to minutes, snap to grid, convert back
            var deltaMinutes = that.pixelsToMinutes(deltaX);
            var snapTo = that.opts.snapTo;
            var snappedMinutes = Math.round(deltaMinutes / snapTo) * snapTo;
            var snappedPixels = that.minutesToPixels(snappedMinutes);
            $apptDragEl.css('transform', 'translateX(' + snappedPixels + 'px)');
        });

        $(document).on('mouseup' + ns, function(e) {
            if (!$apptDragEl) return;

            if (apptDragStarted) {
                wasDraggingAppointment = true;

                var deltaX = e.pageX - apptDragStartX;
                var deltaMinutes = that.pixelsToMinutes(deltaX);

                var snapTo = that.opts.snapTo;
                var snappedDelta = Math.round(deltaMinutes / snapTo) * snapTo;

                var newStart = apptDragOrigStart + snappedDelta;
                var newEnd = apptDragOrigEnd + snappedDelta;
                var duration = apptDragOrigEnd - apptDragOrigStart;

                if (that.wrapEnd) {
                    var gridRange = that.wrapEnd - that.minMinutes;
                    var normalizedOffset = ((newStart - that.minMinutes) % gridRange + gridRange) % gridRange;
                    newStart = that.minMinutes + normalizedOffset;
                    newEnd = newStart + duration;
                    if (newEnd > that.wrapEnd) {
                        newStart = that.minMinutes;
                        newEnd = that.minMinutes + duration;
                    }
                } else {
                    if (newStart < that.minMinutes) {
                        newStart = that.minMinutes;
                        newEnd = newStart + duration;
                    }
                    if (newEnd > that.maxMinutes) {
                        newEnd = that.maxMinutes;
                        newStart = newEnd - duration;
                    }
                }

                $apptDragEl.css('transform', '');
                $apptDragEl.removeClass('sjs-dragging');

                if (that.opts.onDragEnd) {
                    that.opts.onDragEnd.call(that, {
                        id: apptDragPayload.id,
                        payload: apptDragPayload,
                        oldStart: toHHMM(apptDragOrigStart),
                        oldEnd: toHHMM(apptDragOrigEnd),
                        newStart: toHHMM(newStart),
                        newEnd: toHHMM(newEnd)
                    });
                }
            }

            $apptDragEl = null;
            apptDragStarted = false;
        });
    };

    // ── Destroy (direct prototype method for internal + API use) ─

    Scheduler.prototype.destroy = function() {
        if (this._timeLineInterval) clearInterval(this._timeLineInterval);
        this._hideContextMenu();
        $(document).off('.schedulerPopup');
        $(document).off('.schedulerTab');
        $(document).off('.schedulerjsApptDrag' + this._instanceId);
        this.$element.off('.schedulerjs');
        this.$element.removeData(pluginName);
        this.$element.empty();
    };

    // ── Public API ──────────────────────────────────────────────

    Scheduler.prototype.public = {
        selected: function() {
            return {
                start: this.minutesToTimeStr(this.start),
                end: this.minutesToTimeStr(this.end)
            };
        },
        start: function(time) {
            if (time !== undefined) {
                this.start = this.timeStrToMinutes(time);
                this._updateSelector();
            }
            return this.minutesToTimeStr(this.start);
        },
        end: function(time) {
            if (time !== undefined) {
                this.end = this.timeStrToMinutes(time);
                this._updateSelector();
            }
            return this.minutesToTimeStr(this.end);
        },
        update: function(list) {
            var $appCol = this.$element.find('.sjs-app-col').first();
            var savedScrollLeft = $appCol.length ? $appCol.scrollLeft() : 0;

            this.nameList = [];
            this.payloadById = {};
            this.opts.list = list;
            this._buildDOM();
            this._updateSelector();

            $appCol = this.$element.find('.sjs-app-col').first();
            if ($appCol.length) {
                $appCol.scrollLeft(savedScrollLeft);
            }
        },
        showSelector: function() {
            this.$element.find('.sjs-selector').show();
        },
        hideSelector: function() {
            this.$element.find('.sjs-selector').hide();
        },
        toggleSelector: function() {
            this.$element.find('.sjs-selector').toggle();
        },
        destroy: function() {
            Scheduler.prototype.destroy.call(this);
        }
    };

    // ── jQuery Plugin Registration ──────────────────────────────

    $.fn[pluginName] = function(opts) {
        var args = Array.prototype.slice.call(arguments, 1);
        var retVal;

        this.each(function() {
            var plugin = $.data(this, pluginName);

            // Destroy existing instance before re-initializing
            if (typeof opts === 'object' && plugin) {
                var savedScrollLeft = $(this).find('.sjs-app-col').first().scrollLeft() || 0;
                plugin.destroy();
                plugin = null;
                $(this).data(pluginName + '_savedScroll', savedScrollLeft);
            }

            if (!plugin) {
                if (typeof opts !== 'object') {
                    $.error(pluginName + ' needs an options object for initialization.');
                    return;
                }
                $.data(this, pluginName, new Scheduler($(this), opts));
            }

            plugin = $.data(this, pluginName);

            if (typeof opts !== 'object') {
                if (plugin.public[opts]) {
                    retVal = plugin.public[opts].apply(plugin, args);
                } else {
                    $.error('Method ' + opts + ' does not exist in ' + pluginName);
                }
            }
        });

        return retVal !== undefined ? retVal : this;
    };

})(jQuery, window, document);
